import React from 'react';
import { InStoreOutlined } from 'jl-design-system/components/icons/InStoreOutlined';
import { sendEvent } from '@JohnLewisPartnership/experiments-utils';
import styles from './store-finder-icon.scss';

export const StoreFinderIcon = () => {
  const handleOnClick = () => {
    sendEvent('nav.mobile.store-finder');
  };

  return (
    <a
      className={styles.link}
      href="/our-shops"
      data-test="store-finder-anchor"
      data-testid="store-finder-anchor"
      aria-label="Store finder"
      onClick={handleOnClick}
    >
      <InStoreOutlined
        className={styles.icon}
        size="medium"
        title="Store Finder"
      />
      <span className={styles.label} data-testid="store-finder-icon-label">
        Stores
      </span>
    </a>
  );
};
